import { render, staticRenderFns } from "./LabElementEdit.vue?vue&type=template&id=6ad65688"
import script from "./LabElementEdit.vue?vue&type=script&lang=js"
export * from "./LabElementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports